import LegalLayout, { Section } from "../LegalLayout";
import { BUSINESS } from "../businessInfo";

export default function RefundPage() {
  return (
    <LegalLayout
      title="Refund & Cancellation Policy"
      intro={
        <p>
          This policy explains cancellations and refunds for {BUSINESS.brandName} subscriptions
          operated by {BUSINESS.legalName}, and clarifies how refunds work for food orders placed
          through a Merchant.
        </p>
      }
    >
      <Section heading="1. Subscription cancellations">
        <p>
          You can cancel your {BUSINESS.brandName} subscription at any time from your account billing
          settings or by emailing{" "}
          <a className="text-primary-600 hover:text-primary-700" href={`mailto:${BUSINESS.supportEmail}`}>
            {BUSINESS.supportEmail}
          </a>. Cancellation stops future renewals; your plan stays active until the end of the period
          you have already paid for.
        </p>
      </Section>

      <Section heading="2. Subscription refunds">
        <p>
          If you are not satisfied, you may request a refund within {BUSINESS.refundWindowDays} days of
          a payment. Approved refunds are issued to the original payment method via Razorpay, typically
          within 5–7 business days (your bank may take additional time).
        </p>
        <p>Refunds are generally <strong>not</strong> available for:</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>Renewals after the refund window has passed;</li>
          <li>Accounts suspended or terminated for breach of our Terms;</li>
          <li>Add-ons or usage already consumed.</li>
        </ul>
      </Section>

      <Section heading="3. Food orders placed through a Merchant">
        <p>
          For food and beverage orders placed through a restaurant's QR menu, the contract is between
          the guest and the restaurant (the Merchant). Refunds, cancellations, and complaints about an
          order are handled by that Merchant per their own policy. {BUSINESS.brandName} acts only as the
          technology facilitator and can help connect you with the Merchant where needed.
        </p>
      </Section>

      <Section heading="4. Failed or duplicate payments">
        <p>
          If you are charged but your subscription does not activate, or you are charged twice for the
          same order, contact us at{" "}
          <a className="text-primary-600 hover:text-primary-700" href={`mailto:${BUSINESS.supportEmail}`}>
            {BUSINESS.supportEmail}
          </a>{" "}with the payment reference. Verified failed/duplicate charges are refunded in full.
        </p>
      </Section>

      <Section heading="5. How to request a refund">
        <p>
          Email{" "}
          <a className="text-primary-600 hover:text-primary-700" href={`mailto:${BUSINESS.supportEmail}`}>
            {BUSINESS.supportEmail}
          </a>{" "}or call {BUSINESS.supportPhone} with your account email and the payment reference. We
          aim to respond within 2 business days.
        </p>
      </Section>
    </LegalLayout>
  );
}
